import PropTypes from 'prop-types'
import React from 'react'
import Input from '../ui/Input'

const InputLabel = React.forwardRef((props, ref) => {
  const { name, label, classNameLabel, classNameInput, ...rest } = props

  return (
    <>
      <label className={classNameLabel} htmlFor={name}>
        {label}
      </label>
      <Input {...rest} ref={ref} className={classNameInput} name={name} />
    </>
  )
})
InputLabel.displayName = 'InputLabel'
InputLabel.defaultProps = {
  type: 'text'
}

InputLabel.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'email', 'date', 'number', 'password']),
  label: PropTypes.string.isRequired,
  classNameLabel: PropTypes.string,
  classNameInput: PropTypes.string,
  error: PropTypes.string
}

export default InputLabel
